module.exports = {
	"name": "Terrain",
	"desc": "Shaded relief with custom colors based on elevation and climate data (humid lowlands are green and arid lowlands are brown).",
	"useHighResMaps": true,
	"maps": [
		{
			"name": "basemap",
			"displayName": "Terrain"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/resources/data/terrain-info.json
// module id = 1154
// module chunks = 0